import { apiSlice } from "@app/api/apiSlice";

export const globalSettingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllSettings: builder.mutation({
      query: (query) => `setting/all?${query}`,
    }),
    loadTypeRequest: builder.query({
      query: () => `setting/all/type`,
    }),
    loadSubTypeRequest: builder.query({
      query: (id) => `setting/all/subtype/${id}`,
    }),
    loadOneDetails: builder.mutation({
      query: (id) => `setting/single/${id}`,
    }),
    saveOneDetails: builder.mutation({
      query: (body) => ({
        url: `setting/${body.type}`,
        method: "POST",
        body,
      }),
    }),
    deleteSetting: builder.mutation({
      query: (id) => ({
        url: `setting/delete/${id}`,
        method: "DELETE",
      }),
    }),

    deleteRedisDB: builder.mutation({
      query: () => ({
        url: `setting/redis/flush/db`,
        method: "GET",
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadAllSettingsMutation,
  useLoadTypeRequestQuery,
  useLoadSubTypeRequestQuery,
  useLoadOneDetailsMutation,
  useSaveOneDetailsMutation,
  useDeleteSettingMutation,
  useDeleteRedisDBMutation,
} = globalSettingsApiSlice;
